import { Person } from '../swagger';

export const personsTranslations: Record<Person.TypeEnum, string> = {
  [Person.TypeEnum.Main]: 'main_applicant',
  [Person.TypeEnum.Spouse]: 'spouse',
  [Person.TypeEnum.Child]: 'children',
};
